import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ContentPage } from 'src/app/enums/content-page.enum';
import { HealthComponent } from 'src/app/shared/health/health.component';

@Component({
  selector: 'app-professionals',
  templateUrl: './professionals.component.html',
  styleUrls: ['./professionals.component.scss']
})
export class ProfessionalsComponent implements OnInit {
  greetings = ContentPage.esES.health.greetings;
  profesional = ContentPage.esES.health.profesional;

  constructor(
    private router: Router,
    private dialog: MatDialog
  ) { }

  ngOnInit() {
    let language = localStorage.getItem('language');
    if (language == 'esEN') {
      this.greetings = language == 'esEN' ? ContentPage.esEN.health.greetings : ContentPage.esES.health.greetings;
      this.profesional = language == 'esEN' ? ContentPage.esEN.health.profesional : ContentPage.esES.health.profesional;
    }
    setTimeout(() => {
      this.showHealthModal();
    });
  }

  changeSelected(item: any) { 
    this.profesional.forEach(x => {
      x.selected = false;
    });
    item.selected = !item.selected;
    this.router.navigateByUrl(item.path);
  }

  showHealthModal(){
    this.dialog.open(HealthComponent,{
      width: '1196px',
      maxHeight: '90vh',
      disableClose: true
    })
  }


}
